(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.fancybox = {
    attach: function (context, settings) {
      if (typeof context['location'] !== 'undefined') {       
        
        
        
        
        if(document.querySelector('.fancybox.lightbox')) {
          return;
        }
        var videoURLs = document.querySelectorAll('.video_paragraph .field--type-link a');
        var urlArray = [];
        if(videoURLs) {
          for(var i = 0; i < videoURLs.length; i++) {
            urlArray.push(videoURLs[i].innerHTML);
            videoURLs[i].style.display = 'none';
          }
        }

        var videoContainers = document.querySelectorAll('.video_paragraph .fancybox');
        var videoButtons = document.querySelectorAll('.video_paragraph .play_container');
        var images = document.querySelectorAll('.video_paragraph .fancybox .image-container');

        if(videoURLs && videoContainers && images){

          for(var i = 0; i < images.length; i ++) {
            images[i].appendChild(videoButtons[i]);
            videoContainers[i].setAttribute('href', videoURLs[i]);
            videoContainers[i].classList.add('lightbox');
            videoContainers[i].setAttribute('data-fancybox','');
            videoContainers[i].setAttribute('data-fancybox-type', 'iframe');
          }
        }
        //t&m
        var videoURLsTM = document.querySelectorAll('.pg-text-media__media .field--type-link a');
        var urlArrayTM = [];
        if(videoURLsTM) {
          for(var i = 0; i < videoURLsTM.length; i++) {
            urlArrayTM.push(videoURLsTM[i].innerHTML);
            videoURLsTM[i].style.display = 'none';
          }
        }

        var videoContainersTM = document.querySelectorAll('.pg-text-media__media .fancybox');
        var videoButtonsTM = document.querySelectorAll('.pg-text-media__media .play_container');
        var imagesTM = document.querySelectorAll('.pg-text-media__media .fancybox .image-container');

        if(videoURLsTM && videoContainersTM && imagesTM){

          for(var i = 0; i < imagesTM.length; i ++) {
            imagesTM[i].appendChild(videoButtonsTM[i]);
            videoContainersTM[i].setAttribute('href', videoURLsTM[i]);
            videoContainersTM[i].classList.add('lightbox');
            videoContainersTM[i].setAttribute('data-fancybox','');
            videoContainersTM[i].setAttribute('data-fancybox-type', 'iframe');
          }
        }
        $('.lightbox').fancybox({
          type: "iframe"
        });
        
        // http://fancyapps.com/fancybox/3/docs/

              // http://fancyapps.com/fancybox/3/docs/

      }
    }
  };

})(jQuery, Drupal, this, this.document);
